/**
 * @class {T.Top}
 * @extends {mkE.Base}
 * @param {DR.ApiCall} apiCall
 * @param {Object} apiCallParams
 * @param {Object} par
 */
T.Top = Class(
	/**
	 * @lends {T.Top#}
	 */
	{
		/** @type {DR.events.struct.Event} */
		event: null,
		_openRow: null,
		_searchTO: null,
		_onSearchKeyUpTO: null,
		_lastKeyword: null,
		_teams: [],
		_fullTop: false,
		_hasGames: false,
		_hasTasks: true,
		_key: 'event.top.',

		/**
		 * @param {DR.ApiCall} apiCall
		 * @param {Object} apiCallParams
		 * @param {Object} par
		 * @constructs
		 */
		__construct(apiCall, apiCallParams, par) {
			par = par || {};
			if( typeof par.hasGames !== 'undefined' ) {
				this._hasGames = par.hasGames;
			}
			if( typeof par.hasTasks !== 'undefined' ) {
				this._hasTasks = par.hasTasks;
			}
			if( typeof par.key !== 'undefined' ) {
				this._key = par.key + '.';
			}

			this._mGetEvent = new DR.events.Get();
			this._mGetEvent.onLoad = () => {
				this.event = this._mGetEvent.re
			};
			this._mGetEvent.select = [
				new DR.events.select.Event().id().seoTitle().settings()
			];

			this._mGetTop = new DR.top.GetTop();
			this._mGetTop.pg = 1;
			this._mGetTop.count = par.count || 12;
			this._mGetTop.onLoad = this._onTop;
			this._mGetTop.select = [
				new DR.teams.select.Team().id().title().image(),
				new DR.roadgames.select.Image().small()
			];

			this._mGetTeams = new DR.top.GetTeams();
			this._mGetTeams.onLoad = this._onTeams;

			let callApi = false;
			if (!(apiCall instanceof DR.ApiCall)) {
				apiCall = new DR.ApiCall();
				callApi = true;
			}
			apiCall.addMethod(this._mGetEvent);
			apiCall.addMethod(this._mGetTop);
			if (par.searchContainer) {
				apiCall.addMethod(this._mGetTeams);
			}
			if (callApi) {
				apiCall.call(apiCallParams);
			}

			this.node = mkE({
				tag: 'div',
				className: 'results-table'
			});

			if( par.className ) {
				addClassName(this.node, 'results-table-' + par.className);
			}

			if (par.searchContainer) {
				this._initSearch(par.searchContainer);
			}
		},

		_onTeams() {
			this._teams = this._mGetTeams.re.teams.map((team) => {
				team.normalizedName = this._normalize(team.name);
				return team;
			});
		},

		_onTop() {
			this._fullTop = true;
			this._drawTopPage(this._mGetTop.re.items || [], this._mGetTop.pg, this._mGetTop.re.pgs);
		},

		_drawTopPage(teams, pg, pgs) {
			this._openRow = null;
			let items = [];
			if (this._hasTasks) {
				if (this.event.settings.hasPhotoMatching) {
					items.push('imagematch');
				}
				if (this.event.settings.hasQuestions) {
					items.push('question');
				}
				if (this.event.settings.hasHotCold) {
					items.push('hotcold');
				}
				if (this.event.settings.hasCrazyWolves) {
					items.push('crazywolf');
				}
				if (this.event.settings.hasBrainTeaser) {
					items.push('brainteaser');
				}
				if (this.event.settings.hasPacman) {
					items.push('pacman');
				}
				if (this.event.settings.hasCoder) {
					items.push('coder');
				}
				if (this.event.settings.hasDetective) {
					items.push('detective');
				}
				if (this.event.settings.hasGoldDigger) {
					items.push('golddigger');
				}
				if (this.event.settings.hasTreasure) {
					items.push('treasure');
				}
				items.push('penalty');
			}
			if (!this._header) {
				this._header = mkE({
					tag: 'div',
					className: 'row header row-' + items.length,
					els: [
						{
							tag: 'div',
							className: 'text place',
							text: D.Lang.get(this._key + 'place')
						},
						{
							tag: 'div',
							className: 'text name',
							text: D.Lang.get(this._key + 'name')
						},
						{
							tag: 'div',
							className: 'text time',
							text: D.Lang.get(this._key + 'time')
						},
						this._hasGames ? {
							tag: 'div',
							className: 'text games',
							text: D.Lang.get(this._key + 'games')
						} : ''
					]
				}).append(this.node);
				let tasks = mkE({
					tag: 'div',
					className: 'tasks'
				}).append(this._header);
				items.forEach(task => {
					let headerIcon = mkE({
						tag: 'div',
						className: 'icon icon-' + task
					}).append(tasks);
					tippy(headerIcon, {
						content: D.Lang.get('event.results.tasks.' + task),
						arrow: true
					});
				});
				mkE({
					tag: 'div',
					className: 'text total',
					text: D.Lang.get(this._key + 'points')
				}).append(this._header);
			}
			if (!this._items) {
				this._items = mkE({
					tag: 'div'
				}).append(this.node);
			}
			D.removeLoadingOverlay(this._items);
			clearNode(this._items);

			for (let i = 0; i < teams.length; i++) {
				const item = teams[i];
				let row = mkE({
					tag: 'div',
					className: 'row row-' + items.length + (this._fullTop ? '' : ' open'),
					els: [
						{
							tag: 'div',
							className: 'image',
							style: {
								backgroundImage: 'url(' + item.team.image.small + ')'
							}
						},
						{
							tag: 'div',
							className: 'place',
							text: item.place + '.'
						},
						{
							tag: 'div',
							className: 'name',
							text: item.team.title
						},
						{
							tag: 'div',
							className: 'time',
							text: this._formatDuration(item.duration)
						},
						this._hasGames ? {
							tag: 'div',
							className: 'games',
							text: item.games
						} : ''
					],
					prop: {
						onclick: (e) => {
							if (!this._fullTop) {
								return;
							}
							if (!this._hasTasks) {
								return;
							}
							if (e.currentTarget === this._openRow) {
								removeClassName(e.currentTarget, 'open');
								this._openRow = null;
								return;
							}
							if (this._openRow) {
								removeClassName(this._openRow, 'open');
							}
							addClassName(e.currentTarget, 'open');
							this._openRow = e.currentTarget;
						}
					}
				}).append(this._items);

				let results = {};
				for (let j = 0; j < item.tasks.length; j++) {
					const task = item.tasks[j];
					results[task.type] = task.points;
				}

				let tasks = mkE({
					tag: 'div',
					className: 'tasks'
				}).append(row);
				items.forEach(item => {
					mkE({
						tag: 'div',
						className: 'result',
						els: [
							{
								tag: 'div',
								className: 'result-icon icon-' + item
							},
							{
								tag: 'div',
								className: 'result-text',
								text: D.Lang.get('event.results.tasks.' + item)
							},
							{
								tag: 'div',
								className: 'result-line'
							},
							{
								tag: 'div',
								className: 'result-points',
								text: results[item] || 0
							}
						]
					}).append(tasks);
				});

				mkE({
					tag: 'div',
					className: 'total',
					text: item.points
				}).append(row);
			}

			if (this._fullTop) {
				new T.Pg({
					pg: pg,
					pgs: pgs,
					callback: this._drawTopLoadPg
				}).append(this._items);
			}
		},

		_drawTopLoadPg(pg) {
			D.loadingOverlay(this._items, {
				delay: true
			});
			this._mGetTop.pg = pg;
			this._mGetTop.call({
				eventSeoTitle: this.event.seoTitle,
				eventId: this.event.id
			});
		},

		_formatDuration(duration) {
			let hours = Math.floor(duration / 3600);
			let minutes = Math.floor((duration - (hours * 3600)) / 60);
			let seconds = duration - (hours * 3600) - (minutes * 60);
			let parts = [];
			if (hours) {
				parts.push(hours);
				minutes = String(minutes).padStart(2, '0');
			}
			seconds = String(seconds).padStart(2, '0');
			parts.push(minutes);
			parts.push(seconds);
			return parts.join(':');
		},

		_initSearch(container) {
			this._searchInput = new T.Form.AutoComplete({
				placeholder: D.Lang.get('event.results.search.placeholder'),
				border: true,
				onKeyUp: this._onSearchKeyUp,
				onChange: this._onSearchChange,
				button: {
					tag: 'a',
					className: 'button button-pink',
					onclick: this._onSearchChange
				}
			}).append(container);
		},

		_onSearchKeyUp: function ( e ) {
			if (e.code === "Enter" || e.keyCode === 13) {
				this._onSearchChange();
			} else {
				clearTimeout(this._onSearchKeyUpTO);
				this._onSearchKeyUpTO = setTimeout(this._populateAutoComplete, 300);
			}
		},

		_populateAutoComplete: function () {
			const value = this._normalize(this._searchInput.value()) || '';
			const tags = [];
			if (value.length > 0) {
				for (const team of this._teams) {
					if (team.normalizedName.search(value) !== 0) {
						continue;
					}
					tags.push({
						caption: team.name,
						value: team.name
					});
					if (tags.length >= 5) {
						break;
					}
				}
			}
			this._searchInput.setAutocompleteItems(tags);
		},

		_normalize: function (str) {
			return str.toLowerCase().normalize('NFKD').replace(/[^\w\s]/g, '');
		},

		_onSearchChange: function () {
			const kw = this._searchInput.value();
			if (this._lastKeyword === kw) {
				return;
			}
			this._lastKeyword = kw;
			this.search();
		},

		search: function (delay) {
			clearTimeout(this._searchTO);
			if (delay > 0) {
				this._searchTO = setTimeout(this._onSearch, delay);
			} else {
				this._onSearch();
			}
		},

		_onSearch: function () {
			if (!this._lastKeyword) {
				this._onTop();
				return;
			}
			let team = this._teams.find(team => team.name === this._searchInput.value())
			if (!team) {
				this._onTop();
				return;
			}
			this._mGetTeam = new DR.top.GetTeam();
			this._mGetTeam.teamId = team.id;
			this._mGetTeam.onLoad = this._drawSingleTeam;
			this._mGetTeam.select = [
				new DR.teams.select.Team().id().title().image(),
				new DR.roadgames.select.Image().small()
			];
			this._mGetTeam.call({
				eventSeoTitle: this.event.seoTitle,
				eventId: this.event.id
			});
		},

		_drawSingleTeam() {
			this._fullTop = false;
			this._drawTopPage([this._mGetTeam.re], 1, 1);
		}
	},
	mkE.Base
);
